// extracted by mini-css-extract-plugin
export default {"root":"_392pS"};